import config from '../../../config';

export const SEXOS = { Hombre: 1, Mujer: 2 };
export const VIVEN = { Solo: 0, Pareja: 1, Familiares: 2 };
export const EDUCACION = {
  'Sin estudios': 0,
  'Estudios primarios incompletos': 1,
  'Estudios primarios': 2,
  'Estudios secundarios': 3,
  'Estudios universitarios': 4,
};

export const GRUPOS = config?.GRUPOS || {};
export const GRUPOS_KEYS = Object.keys(GRUPOS).map(Number).sort((a, b) => a - b);

export const getGrupoName = (grupoCode) => GRUPOS[grupoCode] || 'Sin definir';

export const PACIENTE_ACTIONS = [
  { label: 'Entrevista Clinica', path: 'crear-entrevista', icon: 'entrevista' },
  { label: 'Antropometria', path: 'crear-antropometria', icon: 'antropometria' },
  { label: 'Prueba Fuerza Presion', path: 'crear-fuerza-presion', icon: 'fuerza' },
  { label: 'SPPB / TUG', path: 'crear-sppb-tug', icon: 'capacidad' },
  { label: '5STS / Encoder', path: 'crear-5sts-encoder', icon: 'encoder' },
  { label: 'Cuestionarios', path: 'crear-test-nuevos', icon: 'cuestionarios' },
];

export const PACIENTE_CUESTIONARIOS = [
  { label: 'VENT', path: 'crear-vent' },
  { label: 'SP', path: 'crear-sp' },
  { label: 'Tesis Torres', path: 'crear-tesis' },
  { label: 'Anadir Cuestionario', path: 'crear-cuestionarios' },
];
